import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import { AuthProvider } from "./context/AuthContext";
import { FeaturesProvider } from "./context/FeaturesContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";
import { ManualeShell } from "./components/ManualeShell";
import ManualeReader from "./pages/ManualeReader";

import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import Dashboard from "./pages/Dashboard";
import ServiceDetail from "./pages/ServiceDetail";
import SearchCategory from "./pages/SearchCategory";
import History from "./pages/History";
import Profile from "./pages/Profile";
import AdminUsers from "./pages/admin/Users";
import AdminLogs from "./pages/admin/Logs";
import AdminServices from "./pages/admin/Services";
import AdminAnalytics from "./pages/admin/Analytics";
import AdminStorage from "./pages/admin/Storage";
import AdminAiUsage from "./pages/admin/AiUsage";
import DevPreview from "./pages/DevPreview";
import SuperAdminOrganizations from "./pages/superadmin/Organizations";
import SuperAdminOrgDetail from "./pages/superadmin/OrgDetail";
import SuperAdminPricing from "./pages/superadmin/Pricing";
import SuperAdminRevenue from "./pages/superadmin/Revenue";
import SuperAdminSubscriptions from "./pages/superadmin/Subscriptions";
import SuperAdminCosts from "./pages/superadmin/Costs";
import SuperAdminRequests from "./pages/superadmin/Requests";
import SuperAdminUsers from "./pages/superadmin/Users";
import SuperAdminAiConfig from "./pages/superadmin/AiConfig";
import SuperAdminErrors from "./pages/superadmin/Errors";
import Assistant from "./pages/Assistant";
import Documents from "./pages/Documents";
import Attendance from "./pages/Attendance";
import EnergiaMercato from "./pages/EnergiaMercato";
import Support from "./pages/Support";
import InternalMessages from "./pages/InternalMessages";
import ServicesCatalog from "./pages/Services";
import Formazione from "./pages/Formazione";
import Meetings from "./pages/Meetings";
import ChecklistPage from "./pages/Checklist";
import SuperAdminTenantFeatures from "./pages/superadmin/TenantFeatures";
import SuperAdminFormazioneCatalog from "./pages/superadmin/FormazioneCatalog";
import SuperAdminDiscovery from "./pages/superadmin/Discovery";
import SuperAdminDiscoveryDetail from "./pages/superadmin/DiscoveryDetail";
import SuperAdminDiscoveryCompare from "./pages/superadmin/DiscoveryCompare";
import SuperAdminAiCosts from "./pages/superadmin/AiCosts";
import ReconcileFiles from "./pages/ReconcileFiles";
import AskFile from "./pages/AskFile";
import AnalyzeDoc from "./pages/AnalyzeDoc";
import QualityCheck from "./pages/QualityCheck";
import Drafts from "./pages/Drafts";
import DiscoveryPublic from "./pages/public/Discovery";
import PlansPublic from "./pages/public/Plans";
import Signup from "./pages/public/Signup";
import VerifyEmail from "./pages/public/VerifyEmail";
import BillingSuccess from "./pages/BillingSuccess";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <FeaturesProvider>
            <Toaster richColors />
          <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/plans" element={<PlansPublic />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/d/:slug" element={<DiscoveryPublic />} />
            <Route
              path="/billing/success"
              element={
                <ProtectedRoute>
                  <BillingSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/services" element={<ServicesCatalog />} />
              <Route path="/search/:category_slug" element={<SearchCategory />} />
              <Route path="/service/:service_id" element={<ServiceDetail />} />
              <Route path="/history" element={<History />} />
              <Route path="/assistant" element={<Assistant />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/assistant/reconcile" element={<ReconcileFiles />} />
              <Route path="/assistant/ask-file" element={<AskFile />} />
              <Route path="/assistant/analyze-doc" element={<AnalyzeDoc />} />
              <Route path="/assistant/quality" element={<QualityCheck />} />
              <Route path="/assistant/drafts" element={<Drafts />} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/energia/mercato" element={<EnergiaMercato />} />
              {/* Punti e Flussi: spenti per tutti (vedi PUNTI_FLUSSI_SPENTI nel backend) */}
              <Route path="/support" element={<Support />} />
              <Route path="/messages" element={<InternalMessages />} />
              <Route path="/checklist" element={<ChecklistPage />} />
              <Route path="/formazione" element={<Formazione />} />
              <Route path="/meetings" element={<Meetings />} />
              <Route path="/profile" element={<Profile />} />

              <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
              <Route path="/admin/services" element={<ProtectedRoute adminOnly><AdminServices /></ProtectedRoute>} />
              <Route path="/admin/logs" element={<ProtectedRoute adminOnly><AdminLogs /></ProtectedRoute>} />
              <Route path="/admin/analytics" element={<ProtectedRoute adminOnly><AdminAnalytics /></ProtectedRoute>} />
              <Route path="/admin/storage" element={<ProtectedRoute adminOnly><AdminStorage /></ProtectedRoute>} />
              <Route path="/admin/ai" element={<ProtectedRoute adminOnly><AdminAiUsage /></ProtectedRoute>} />
              <Route path="/superadmin/organizations" element={<ProtectedRoute superAdminOnly><SuperAdminOrganizations /></ProtectedRoute>} />
              <Route path="/superadmin/organizations/:org_id" element={<ProtectedRoute superAdminOnly><SuperAdminOrgDetail /></ProtectedRoute>} />
              <Route path="/superadmin/pricing" element={<ProtectedRoute superAdminOnly><SuperAdminPricing /></ProtectedRoute>} />
              <Route path="/superadmin/revenue" element={<ProtectedRoute superAdminOnly><SuperAdminRevenue /></ProtectedRoute>} />
              <Route path="/superadmin/subscriptions" element={<ProtectedRoute superAdminOnly><SuperAdminSubscriptions /></ProtectedRoute>} />
              <Route path="/superadmin/costs" element={<ProtectedRoute superAdminOnly><SuperAdminCosts /></ProtectedRoute>} />
              <Route path="/superadmin/requests" element={<ProtectedRoute superAdminOnly><SuperAdminRequests /></ProtectedRoute>} />
              <Route path="/superadmin/users" element={<ProtectedRoute superAdminOnly><SuperAdminUsers /></ProtectedRoute>} />
              <Route path="/superadmin/ai-config" element={<ProtectedRoute superAdminOnly><SuperAdminAiConfig /></ProtectedRoute>} />
              <Route path="/superadmin/ai-costs" element={<ProtectedRoute superAdminOnly><SuperAdminAiCosts /></ProtectedRoute>} />
              <Route path="/superadmin/errori" element={<ProtectedRoute superAdminOnly><SuperAdminErrors /></ProtectedRoute>} />
              <Route path="/superadmin/tenant-features" element={<ProtectedRoute superAdminOnly><SuperAdminTenantFeatures /></ProtectedRoute>} />
              <Route path="/superadmin/formazione" element={<ProtectedRoute superAdminOnly><SuperAdminFormazioneCatalog /></ProtectedRoute>} />
              <Route path="/superadmin/discovery" element={<ProtectedRoute superAdminOnly><SuperAdminDiscovery /></ProtectedRoute>} />
              <Route path="/superadmin/discovery/confronto" element={<ProtectedRoute superAdminOnly><SuperAdminDiscoveryCompare /></ProtectedRoute>} />
              <Route path="/superadmin/discovery/:id" element={<ProtectedRoute superAdminOnly><SuperAdminDiscoveryDetail /></ProtectedRoute>} />
              <Route path="/dev/preview/:slug" element={<DevPreview />} />
            </Route>

            {/* Manuale a pagina intera: barra Wattline + lettore, nessuna cornice */}
            <Route
              element={
                <ProtectedRoute>
                  <ManualeShell />
                </ProtectedRoute>
              }
            >
              <Route path="/formazione/:slug/:pos?" element={<ManualeReader />} />
            </Route>

            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          </FeaturesProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
